import { SynopticStyleDefinition } from '@connect-services/client/components/synoptic/synoptic-graph/graph-core/synoptic-graph.model';

export const ELK_OPTIONS = {
    elk: {
        algorithm: 'layered',
        alignment: 'CENTER',
        hierarchyHandling: 'INCLUDE_CHILDREN',
        'layered.crossingMinimization.greedySwitch.activationThreshold': 1,
        'layered.crossingMinimization.greedySwitch.type': 'ONE_SIDED',
        'layered.crossingMinimization.hierarchicalSweepiness': 0.9,
        'layered.crossingMinimization.strategy': 'LAYER_SWEEP',
        'layered.highDegreeNodes.treatment': true,
        'layered.highDegreeNodes.treeHeight': 10,
        'layered.layering.layerConstraint': 'NONE',
        'layered.layering.wideNodesOnMultipleLayers': 'AGGRESSIVE',
        'layered.nodePlacement.bk.fixedAlignment': 'LEFTUP',
        'layered.nodePlacement.strategy': 'NETWORK_SIMPLEX',
        'layered.priority.straightness': 2,
        'layered.spacing.edgeEdgeBetweenLayer': 200,
        'layered.spacing.edgeNodeBetweenLayers': 200,
        'layered.spacing.nodeNodeBetweenLayers': 800,
        'layered.thoroughness': 70,
        'layered.wrapping.strategy': 'OFF',
        'spacing.edgeNode': 150,
        'spacing.nodeNode': 250,
    },
    name: 'elk',
    nodeDimensionsIncludeLabels: true,
};

export const NODE_DEFAULT_Z_INDEX = 1;

export const EDGE_DEFAULT_Z_INDEX = 0;

export const SYNOPTIC_CYTOSCAPE_STYLES: SynopticStyleDefinition[] = [
    {
        selector: 'node',
        style: {
            'background-color': '#FFFFFF',
            'background-image-opacity': 1,
            'border-width': 5,
            color: 'white',
            label: 'data(title)',
            shape: 'polygon',
            'shape-polygon-points': '-0.9, -1,  -1, 0,  -0.9, 1,  0.9, 1,  1, 0,  0.9, -1',
            'text-background-opacity': 1,
            'text-background-padding': '10px',
            'text-background-shape': 'rectangle',
            'text-events': 'yes', // Allow click on label
            'text-margin-y': -10, // (-padding)
            'text-max-width': '1000px',
            'text-overflow-wrap': 'anywhere',
            'text-wrap': 'wrap',
            // Allow selected edge/node to be on top
            'z-index': NODE_DEFAULT_Z_INDEX,
            'z-index-compare': 'manual',
        },
    },
    {
        selector: 'edge',
        style: {
            'arrow-scale': 2,
            color: '#fff',
            'curve-style': 'bezier',
            label: 'data(label)',
            'segment-weights': '0.15 0.85',
            'target-arrow-shape': 'triangle',
            'text-background-color': '#a3a3a3',
            'text-background-opacity': 1,
            'text-background-padding': '4px',
            'text-background-shape': 'rectangle',
            'text-border-opacity': 1,
            'text-border-width': 4,
            'text-events': 'yes', // Allow click on label
            'text-wrap': 'wrap',
            width: 4,
            'z-index': EDGE_DEFAULT_Z_INDEX,
            // Allow selected edge/node to be on top
            'z-index-compare': 'manual',
        },
    },
    {
        selector: 'edge.edges.maintenance',
        style: {
            color: '#fff',
            'line-color': '#b71c1c',
            'target-arrow-color': '#b71c1c',
            'text-background-color': '#b71c1c',
            'text-border-color': '#b71c1c',
        },
    },
    {
        selector: 'node.nodes.maintenance',
        style: {
            'border-color': '#b71c1c',
            'text-background-color': '#b71c1c',
        },
    },
    {
        selector: 'node.nodes.SRO',
        style: {
            shape: 'round-rectangle',
        },
    },
    {
        selector: 'edge.edges.to-create',
        style: {
            color: '#FFFFFF',
            'line-color': '#edb349',
            'target-arrow-color': '#edb349',
            'text-background-color': '#edb349',
            'text-border-color': '#edb349',
        },
    },
    {
        selector: 'node.nodes.to-create',
        style: {
            'border-color': '#edb349',
            'text-background-color': '#edb349',
        },
    },
    {
        selector: 'edge.edges.working',
        style: {
            color: '#FFFFFF',
            'line-color': '#0d47a1',
            'target-arrow-color': '#0d47a1',
            'text-background-color': '#0d47a1',
            'text-border-color': '#0d47a1',
        },
    },
    {
        selector: 'node.nodes.working',
        style: {
            'border-color': 'rgb(13,71,161)',
            'text-background-color': '#0d47a1',
        },
    },
    {
        selector: 'edge.edges.discarded',
        style: {
            color: '#fff',
            'line-color': '#000000',
            'target-arrow-color': '#1b1b1b',
            'text-background-color': '#1b1b1b',
            'text-border-color': '#000000',
        },
    },
    {
        selector: 'node.nodes.discarded',
        style: {
            'border-color': '#000000',
            'text-background-color': '#000000',
        },
    },
    {
        selector: 'edge.edges.existing',
        style: {
            color: '#FFFFFF',
            'line-color': '#1b5e20',
            'target-arrow-color': '#1b5e20',
            'text-background-color': '#1b5e20',
            'text-border-color': '#1b5e20',
        },
    },
    {
        selector: 'node.nodes.existing',
        style: {
            'border-color': '#1b5e20',
            'text-background-color': '#1b5e20',
        },
    },
    {
        selector: 'edge.edges.not-working',
        style: {
            color: '#fff',
            'line-color': '#e971b1',
            'target-arrow-color': '#e971b1',
            'text-background-color': '#e971b1',
            'text-border-color': '#e971b1',
        },
    },
    {
        selector: 'node.nodes.not-working',
        style: {
            'border-color': '#e971b1',
            'text-background-color': '#e971b1',
        },
    },
    {
        selector: 'edge.edges.unknown',
        style: {
            color: '#fff',
            'line-color': '#ba55d3',
            'line-style': 'dashed',
            'target-arrow-color': '#ba55d3',
            'text-background-color': '#ba55d3',
            'text-border-color': '#ba55d3',
        },
    },
    {
        selector: 'node.nodes.unknown',
        style: {
            'border-color': '#ba55d3',
            'text-background-color': '#ba55d3',
        },
    },
    {
        selector: 'edge.edges.has-error',
        style: {
            'line-color': '#ad2b1d',
            'line-dash-pattern': [6, 3],
            'line-style': 'dashed',
            'text-border-color': '#ad2b1d',
            'text-border-style': 'dashed',
            'text-border-width': 5,
        },
    },
    {
        selector: 'node.nodes.has-error',
        style: {
            'text-border-color': '#ad2b1d',
            'text-border-style': 'dashed',
            'text-border-width': 4,
        },
    },
    {
        selector: '.not-hover',
        style: {
            opacity: 0.4,
        },
    },
    {
        selector: '.not-found',
        style: {
            opacity: 0.2,
        },
    },
    {
        selector: ':parent',
        style: {
            'background-opacity': 0,
            label: 'data(label)',
        },
    },
    {
        selector: '.isFocusedNode',
        style: {
            'border-color': 'red',
        },
    },
    {
        selector: '#NRO',
        style: {
            'background-color': '#6e0014',
            'background-opacity': 0.2,
        },
    },
    {
        selector: '.blue',
        style: {
            'border-color': '#0279ff',
            'border-width': 5,
        },
    },
    {
        selector: '.green',
        style: {
            'border-color': '#106600',
            'border-width': 5,
        },
    },
    {
        selector: '.error',
        style: {
            'border-color': '#ff0000',
            'border-width': 5,
        },
    },
    {
        selector: '$:parent > .error',
        style: {
            'border-color': '#ff0000',
            'border-width': 10,
        },
    },
    {
        selector: '$:parent[id != "NRO"] > .hide',
        style: {
            opacity: 0,
        },
    },
    {
        selector: '.hide',
        style: {
            display: 'none',
            opacity: 0,
        },
    },
    {
        selector: '.shadow',
        style: {
            opacity: 0.2,
        },
    },
    {
        selector: '.filtered',
        style: {
            opacity: 0.1,
        },
    },
];
